import React from 'react';
import { View, Text, Dimensions, Image } from 'react-native';
import Modal from 'modal-enhanced-react-native-web';
import { connect } from 'react-redux';

import { completeJourney } from '../../../redux/actions'
import Colors from "../../../constants/Colors";
import { ButtonWithSpinner, Spacing } from "../../../components";

class CompleteJourneyModal extends React.Component {

    state = {
        isFetching: false,
        completeFinished: false,
    }

    completeJourney = async () => {
        if (this.state.isFetching) return;
        this.setState({ isFetching: true })

        try {
            await this.props.completeJourney();
            this.props.onComplete();
        } catch (e) {
            console.log(e);
        }

        this.setState({ isFetching: false })
    }

    render() {

        const { isVisible } = this.props;
        const { height, width } = Dimensions.get('window');

        const modalWidth = width * 0.4;
        const modalHeight = height * 0.6;

        return (
            <Modal
                isVisible={isVisible}
                style={{ alignItems: 'center', justifyContent: 'center' }}
                animationIn={'slideInLeft'}
                animationOut={'slideOutRight'}
            >
                <View style={{
                    height: modalHeight,
                    width: modalWidth,
                    backgroundColor: Colors.cardBackgroundColor,
                    borderRadius: 8,
                    padding: 12,
                    alignItems: 'center',
                    justifyContent: 'space-around'
                }}>
                    <Text style={{ fontSize: 24, color: 'white', fontWeight: 'bold' }}>
                        Treinamento Completo
                    </Text>
                    <Spacing height={12} />
                    <Text style={{ fontSize: 18, color: 'white', textAlign: 'center' }}>
                        Parabéns! Você concluiu o Treinamento!
                    </Text>
                    <Spacing height={12} />
                    <Image
                        source={require('../../../imageImports/trophie-winner.png')}
                        style={{ height: 200, width: 200, }}
                        resizeMode={'contain'}
                    />

                    <Spacing height={12} />

                    <ButtonWithSpinner
                        isLoading={this.state.isFetching}
                        text={'Completar!'}
                        onPress={this.completeJourney}
                        containerPropsStyle={{ height: 40, borderRadius: 8 }}
                        textPropsStyle={{ fontSize: 18, fontWeight: 'bold' }}
                    />
                </View>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        currentJourney: state.journey.currentJourney,
        currentUserProgress: state.journey.currentUserProgress,
    }
}

export default connect(mapStateToProps, { completeJourney })(CompleteJourneyModal);
